import React from "react"
import styles from "./swatches.module.scss"

const Swatches = props => {
  const {
    skus,
    selectedSku,
    updateSelectedSku,
    customStyles
  } = props

  return(
    <ul className={`${styles.swatches} ${(customStyles) ? customStyles.swatches : ""}`}>
      {skus.filter(sku => !!sku.images.swatch)
        .map((sku, i) => (
        <li
          key={i}
          className={styles.swatchItem}
        >
          <button
            className={`${(sku.id === selectedSku.id) ? styles.selected : styles.button} ${(customStyles) ? customStyles.swatchButton : ""}`}
            onClick={() => updateSelectedSku(sku)}
          >
            <img
              src={sku.images.swatch}
              alt={sku.color}
              className={styles.image}
            />
          </button>
        </li>
      ))}
    </ul>
  )
}

export default Swatches
